import { jsxs as p, jsx as e } from "react/jsx-runtime";
import { c as a } from "../../../index-Cu0xwYjD.js";
import { createContext as b, forwardRef as v, useContext as W, useId as B, useState as N, useRef as y } from "react";
import { b as A } from "../../../ThemeContext-CvPyrdCo.js";
import { Heading4 as I } from "../Heading4/Heading4.js";
import { Icon as R } from "../Icon/Icon.js";
import '../../../assets/Accordion.css';const j = "_accordion_8u1a2_4", k = "_accordionExpanded_8u1a2_11", w = "_accordionButton_8u1a2_15", z = "_accordionButtonExpanded_8u1a2_52", G = "_accordionHeader_8u1a2_56", S = "_accordionTitle_8u1a2_69", $ = "_brand_8u1a2_74", P = "_iconContainer_8u1a2_88", q = "_accordionHeaderExpanded_8u1a2_100", D = "_iconContainerExpanded_8u1a2_123", F = "_contentWrapper_8u1a2_146", J = "_contentWrapperExpanded_8u1a2_152", K = "_content_8u1a2_146", L = "_contentExpanded_8u1a2_167", n = {
  accordion: j,
  accordionExpanded: k,
  accordionButton: w,
  accordionButtonExpanded: z,
  accordionHeader: G,
  accordionTitle: S,
  brand: $,
  iconContainer: P,
  accordionHeaderExpanded: q,
  iconContainerExpanded: D,
  contentWrapper: F,
  contentWrapperExpanded: J,
  content: K,
  contentExpanded: L
}, _ = b({
  Header: void 0
}), X = v(
  ({
    children: c,
    title: d,
    expanded: u = !1,
    onToggle: t,
    variant: x = "default",
    ...l
  }, E) => {
    const { Header: m } = W(_), H = m ?? I, r = B(), i = `title-${r}`, [o, f] = N(u), C = y(null), { height: s } = A(), h = () => {
      f(!o), t == null || t(!o);
    };
    return /* @__PURE__ */ p(
      "div",
      {
        ...l,
        className: a(n.accordion, {
          [n.brand]: x === "brand",
          [n.accordionExpanded]: o
        }),
        children: [
          /* @__PURE__ */ e(
            "div",
            {
              className: a(
                n.accordionHeader,
                o && n.accordionHeaderExpanded
              ),
              children: /* @__PURE__ */ e(H, { children: /* @__PURE__ */ p(
                "button",
                {
                  className: a(n.accordionButton, {
                    [n.accordionButtonExpanded]: o
                  }),
                  type: "button",
                  onClick: h,
                  "aria-expanded": o,
                  "aria-controls": r,
                  id: i,
                  ref: E,
                  children: [
                    /* @__PURE__ */ e("span", { className: n.accordionTitle, children: d }),
                    /* @__PURE__ */ e(
                      "div",
                      {
                        className: a(
                          n.iconContainer,
                          o && n.iconContainerExpanded
                        ),
                        children: /* @__PURE__ */ e(R, { name: o ? "minus" : "plus", size: 16 })
                      }
                    )
                  ]
                }
              ) })
            }
          ),
          /* @__PURE__ */ e(
            "div",
            {
              id: r,
              className: a(
                n.contentWrapper,
                o && n.contentWrapperExpanded
              ),
              style: s && o ? { maxHeight: `${s}px` } : void 0,
              role: "region",
              "aria-labelledby": i,
              children: /* @__PURE__ */ e(
                "div",
                {
                  className: a(
                    n.content,
                    o && n.contentExpanded
                  ),
                  ref: C,
                  children: c
                }
              )
            }
          )
        ]
      }
    );
  }
), Y = ({
  children: c,
  headingComponent: d
}) => /* @__PURE__ */ e(_.Provider, { value: { Header: d }, children: /* @__PURE__ */ e("div", { children: c }) });
export {
  X as Accordion,
  Y as AccordionGroup
};
